import { createSlice } from '@reduxjs/toolkit';
import axios from '../../services/authService';
import { API_ENDPOINTS } from '../../config/apiConfig';
import { parseApiResponse } from '../../utilities/parseApiResponse';

export const updateTestFlowSlice = createSlice({
  name: 'updateTestFlow',
  initialState: {
    loading: false,
    response: {},
    error: null,
  },
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.response = {};
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setResponse: (state, action) => {
      state.response = action.payload;
      state.loading = false;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { reset, setLoading, setResponse, setError } = updateTestFlowSlice.actions;

// Function to update flow name and description
export const updateTestFlowAsync = (flowId, changes) => async (dispatch) => {
  dispatch(reset());
  dispatch(setLoading(true));

  try {
    // Map our field names to database field names
    const mappedChanges = {};
    if (changes.flow_name !== undefined) {
      mappedChanges.name = changes.flow_name;
    }
    if (changes.flow_description !== undefined) {
      mappedChanges.description = changes.flow_description;
    }
    if (changes.test_case_id !== undefined) {
      mappedChanges.test_case_id = changes.test_case_id;
    }

    const payload = [
      {
        section_data: 'test-flows',
        id: flowId,
        ...mappedChanges, // Will include name and/or description
      },
    ];

    const response = await axios.put(API_ENDPOINTS.UPDATE_TEST_FLOW, payload);

    const parsedBody = parseApiResponse(response);
    if (parsedBody) {
      dispatch(
        setResponse({
          message: 'Flow updated successfully',
          data: parsedBody,
        }),
      );

      return {
        success: true,
        data: parsedBody,
      };
    }

    return { success: true };
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message || 'Failed to update flow';
    console.error('Error updating flow:', errorMessage);
    dispatch(setError(errorMessage));
    return {
      success: false,
      error: errorMessage,
    };
  }
};

// Selectors
export const selectUpdateTestFlowLoading = (state) => state.updateTestFlow.loading;
export const selectUpdateTestFlowResponse = (state) => state.updateTestFlow.response;
export const selectUpdateTestFlowError = (state) => state.updateTestFlow.error;

export default updateTestFlowSlice.reducer;
